require('./new.jade')
require('./edit.jade')
require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/flash/flash-module')
require('../components/auth/auth-module')
require('../components/form/form-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/error-handler/error-handler-module')

# Load Css
require('../../../sass/web/html/_forgot_password.scss')
require('../../../sass/web/html/_new_password.scss')

PasswordNewCtrl = require('./new-controller')
PasswordEditCtrl = require('./edit-controller')
PasswordService = require('./password-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-flash'
  'gnp-auth'
  'gnp-form'
  'gnp-common-wrapper'
  'gnp-error-handler'
]
angular.module 'gnp-app-password', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider
      .when '/password/new',
        templateUrl: 'web/password/new.jade'
        controller: 'PasswordNewCtrl'
        title: '_PASSWORD.NEW.TITLE'
      .when '/password/edit/:reset_password_token',
        templateUrl: 'web/password/edit.jade'
        controller: 'PasswordEditCtrl'
        title: '_PASSWORD.EDIT.TITLE'
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')
  ]
  .controller 'PasswordNewCtrl', PasswordNewCtrl
  .controller 'PasswordEditCtrl', PasswordEditCtrl
  .factory 'PasswordService', PasswordService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/password/password-module.coffee